import { ChangeDetectionStrategy, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { Modal } from '../services/modal';

@Component({
  selector: 'app-modal-view',
  imports: [NgClass],
  templateUrl: './modal-view.html',
  styleUrl: './modal-view.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalView {
  public readonly modalService = inject(Modal);
  @ViewChild('modalBox') modalElement!: ElementRef;

  closeModal = () => {
    this.modalService.toggle(false);
  }

  constructor() {}
}
